// import _ from '@lodash';
// import store from 'app/store';
// import * as Actions from 'app/store/actions';
import jwtService from "services/jwtService";
import { CookieUtilsInstance } from "utils";

export const SET_USER_DATA = "[USER] SET DATA";
export const REMOVE_USER_DATA = "[USER] REMOVE DATA";
export const USER_LOGGED_OUT = "[USER] LOGGED OUT";

/**
 * Set User Data
 */
export function setUserData(user) {
  return (dispatch) => {
    /*
      Set User Data
    */
    dispatch({
      type: SET_USER_DATA,
      payload: user,
    });
  };
}

/**
 * Remove User Data
 */
export function removeUserData() {
  return {
    type: REMOVE_USER_DATA,
  };
}

/**
 * Logout
 */
export function logoutUser() {
  // return (dispatch, getState) => {
  //   const user = getState().auth.user;

  //   if (!user.role || user.role.length === 0) {
  //     // is guest
  //     return null;
  //   }

  //   history.push({
  //     pathname: "/",
  //   });

  //   switch (user.from) {
  //     default: {
  //       jwtService.logout();
  //     }
  //   }

  //   // dispatch(setInitialSettings());

  //   dispatch({
  //     type: USER_LOGGED_OUT,
  //   });
  // };
  return (dispatch) => {
    const schoolID = CookieUtilsInstance.getCookie("schoolID");
    const semesterID = CookieUtilsInstance.getCookie("semesterID");
    const teacherID = CookieUtilsInstance.getCookie("teacherID");
    const endPointID = CookieUtilsInstance.getCookie("endpointID");

    const isSyncKonjService = window.location.href.search("sync-konj") !== -1;
    window.location.href = `${process.env.REACT_APP_SSO_LOGIN}/${
      isSyncKonjService ? "sync-konj" : "exams"
    }&sei=${semesterID || 0}&sci=${schoolID || 0}&ti=${teacherID || 0}&ei=${
      endPointID || 0
    }`;

    jwtService.logout();

    dispatch({
      type: USER_LOGGED_OUT,
    });
  };
}
